import defaultState from "./state";

const grillaBusquedaReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CARGAR_ELIMINAR_PRESTACION": {
      return Object.assign({}, state, {
        modalEliminarPrestacion: action.modalEliminarPrestacion,
      });
    }

    case "CARGAR_EDITAR_PRESTACION": {
      return Object.assign({}, state, {
        modalEditarPrestacion: action.modalEditarPrestacion,
      });
    }

    case "CAMBIAR_PRESTACION_ELIMINAR": {
      return Object.assign({}, state, {
        idPrestacionEliminar: action.idPrestacionEliminar,
      });
    }

    case "CAMBIAR_PRESTACION_EDITAR": {
      return Object.assign({}, state, {
        idPrestacionEditar: action.idPrestacionEditar,
      });
    }


    // Reducers should always return a default initial state.
    default:
      return state;
  }
};

export default grillaBusquedaReducer;
